import React, { Component } from 'react';
import classNames from 'classnames';

import store from 'store/index';
import StoreGetters from 'store/store-getters';

import { Trans, withTranslation } from 'react-i18next';
import { ReactComponent as StyleToggle_icon_double } from 'asset/image/styleToggle_icon_double.svg';
import multiStyle_icon from 'asset/image/multiStyle_icon.svg';
import closeIcon from 'asset/image/cross.svg';
import CloseIconHover from 'asset/image/icons-close-hover.svg';
import { ReactComponent as MultiStyle_close_icon } from 'asset/image/multiStyle_close_icon.svg';
import { VIEW } from '../config';
import { STATE } from 'services/3dviewer/moving-controls/synchronizeController';

class StyleSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      styles: null,
      selectIndex: 1,
      isDoubleHover: false,
      isFullHover: false,
      isFPview: false,
    };
  }

  componentDidMount() {
    store.subscribe(this.setStyleList);
  }

  changeStyle = mode => {
    this.props.parent.changeView(mode);
  };

  changeStyleIndex = index => {
    this.props.parent.changeSecondStyle(index);
    this.setState({
      selectIndex: index,
    });
  };

  setStyleList = () => {
    const floorStyle = StoreGetters.getCurrentRenderFloorStyles();

    const { viewButton } = store.getState();
    if (viewButton) {
      const { viewState } = viewButton;
      this.setState({
        styles: floorStyle,
        isFPview: viewState == STATE.FPVIEW,
      });
    }
  };

  toggleStyle() {
    if (this.props.mode == VIEW.RIGHTFULL) {
      this.changeStyle(VIEW.DOUBLE);
    } else if (this.props.mode == VIEW.DOUBLE) {
      this.changeStyle(VIEW.RIGHTFULL);
    }
  }

  render() {
    const RWD = this.props.RWD == 'PC' ? '' : '-mobile';
    const { t } = this.props;
    return (
      <div style={{ visibility: this.state.isFPview ? 'visible' : 'hidden' }}>
        {this.props.mode == VIEW.SINGLE && (
          <div className={'select-style-board-close-1' + RWD}>
            <button
              className="select-style-board-close_1"
              onClick={() => this.changeStyle(VIEW.DOUBLE)}
            >
              <img src={multiStyle_icon} />
              <span className="select-style-button-name">
                {t('action.multiStyle')}
              </span>
            </button>
          </div>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            visibility: this.props.mode != VIEW.SINGLE ? 'visible' : 'hidden',
          }}
        >
          <div className="select-style-board-div">
            <div
              style={{
                top: '4px',
                margin: '2px 6px 2px 6px',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '50px',
                position: 'relative',
              }}
            >
              <div
                className={'select-style-board-open-1'}
                style={{
                  top: '3px',
                  margin: '0 20px 0 20px',
                  backgroundColor: 'transparent',
                }}
              >
                <div style={{ display: 'inline-flex' }}>
                  {this.state.styles != null &&
                    Object.keys(this.state.styles).map((b, index) => {
                      if (index != 0) {
                        var styleClass = classNames({
                          'select-style-board_2': true,
                          selected: this.state.selectIndex == index,
                        });
                        return (
                          <button
                            className={styleClass}
                            key={index}
                            onClick={() => this.changeStyleIndex(index)}
                          >
                            <span className="select-style-button-name-1">
                              <Trans> {this.state.styles[b].name}</Trans>
                            </span>
                          </button>
                        );
                      }
                    })}
                </div>
              </div>
            </div>
            <div className={'select-style-board-open-1' + RWD}>
              <button
                className={
                  this.props.mode == VIEW.RIGHTFULL
                    ? 'changeStyleIcon_single'
                    : 'changeStyleIcon_double'
                }
                onClick={() => this.toggleStyle()}
              >
                <StyleToggle_icon_double className="toggleStyleIcon" />
              </button>
            </div>
            <div className={'select-style-board-open-1' + RWD}>
              <button
                className="closeStyleIcon"
                onClick={() => this.changeStyle(VIEW.SINGLE)}
              >
                <MultiStyle_close_icon className="closeStyleIcon_svg" />
              </button>
            </div>
            <div
              className={
                this.props.mode == VIEW.RIGHTFULL
                  ? 'select-style-signal-rightfull'
                  : 'select-style-signal-double'
              }
            >
              {t('action.afterStyle')}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(StyleSelection);
